module.exports = __webpack_public_path__ + "static/img/luyin.7b4b3c6a.svg";